export default [
  {
    path: '/currency',
    name: 'currency',
    component: () => import('@/views/menu/currency/currency.vue'),
    meta: {
      pageTitle: 'مدیریت نرخ ارز',
      action: 'show',
      resource: 'CurrencyManager',
    },
  },
]
